import { CardContent } from '@mui/material';

import { Card, JsonBlock } from '@occc/ui-design-system';

export const TransactionViewFinalizeRequestBody = ({ payload }: { payload: unknown }) => {
  return (
    <Card
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <CardContent>
        <JsonBlock sx={(theme) => ({ fontSize: theme.typography.pxToRem(12) })} object={payload} />
      </CardContent>
    </Card>
  );
};
